import React from 'react';

const variants = {
  primary:    { bg: '#E6FAFB', color: '#009995' },
  osg:        { bg: '#FEF2F2', color: '#DC2626' },
  display:    { bg: '#FFFBEB', color: '#B45309' },
  success:    { bg: '#ECFDF5', color: '#059669' },
  warning:    { bg: '#FFFBEB', color: '#D97706' },
  error:      { bg: '#FEF2F2', color: '#DC2626' },
  gray:       { bg: '#F1F5F9', color: '#64748B' },
  info:       { bg: '#EFF6FF', color: '#2563EB' },
  purple:     { bg: '#F5F3FF', color: '#7C3AED' },
  online:     { bg: '#ECFDF5', color: '#059669' },
  offline:    { bg: '#F1F5F9', color: '#94A3B8' },
  vacation:   { bg: '#FFFBEB', color: '#D97706' },
  urgent:     { bg: '#FEF2F2', color: '#DC2626' },
  normal:     { bg: '#F1F5F9', color: '#64748B' },
  pending:    { bg: '#F1F5F9', color: '#64748B' },
  in_progress:{ bg: '#E6FAFB', color: '#009995' },
  completed:  { bg: '#ECFDF5', color: '#059669' },
  cancelled:  { bg: '#FEF2F2', color: '#DC2626' },
  active:     { bg: '#ECFDF5', color: '#059669' },
  inactive:   { bg: '#F1F5F9', color: '#94A3B8' },
  expired:    { bg: '#FEF2F2', color: '#DC2626' },
  critical:   { bg: '#FFF7ED', color: '#EA580C' },
  ok:         { bg: '#ECFDF5', color: '#059669' },
  confirmed:  { bg: '#ECFDF5', color: '#059669' },
  corrected:  { bg: '#E6FAFB', color: '#009995' },
};

export default function Badge({ variant = 'gray', children, style, dot }) {
  const v = variants[variant] || variants.gray;
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 5,
      padding: '3px 10px',
      borderRadius: 99,
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: '0.01em',
      lineHeight: 1.4,
      background: v.bg,
      color: v.color,
      whiteSpace: 'nowrap',
      ...style,
    }}>
      {dot && (
        <span style={{
          width: 6, height: 6, borderRadius: '50%',
          background: v.color, flexShrink: 0,
        }} />
      )}
      {children}
    </span>
  );
}
